import { inject, Injectable } from '@angular/core';
import { StaysWidget } from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Location } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { DropdownOptions } from '@com-delta-omnichannel/mach-core-js';
import { AemPropertyAccessor } from '../../utils/booking-stays/aem-property-accessor';
import { StaysAirportAdapter } from './stays-airport-adapter';
import { StaysDateAdapter } from './stays-date-adapter';
import { StaysLabelsAdapter } from './stays-labels-adapter';

@Injectable({ providedIn: 'root' })
export class BookingStaysAdapterService {
  private airportAdapter = inject(StaysAirportAdapter);
  private dateAdapter = inject(StaysDateAdapter);
  private labelsAdapter = inject(StaysLabelsAdapter);

  bookingWidgetAem!: HeaderFooterMachCore;

  getContent(aem: HeaderFooterMachCore): StaysWidget {
    this.bookingWidgetAem = aem;
    return {
      locationContent: this.getLocationContent(aem),
      airportModalContent: this.airportAdapter.getAirPortModalContent(aem),
      dropDownDateOption: this.dateAdapter.getDropDownDateOptions(aem),
      dropDownTravelerOption: this.getDropDownTravelOptions(aem),
      dropDownRoomOption: this.getDownRoomOption(aem),
      labels: this.labelsAdapter.getLabels(aem),
      accessibility: this.getAccessibility(aem),
      mdpcid: AemPropertyAccessor.getString(aem, 'mdpcid')
    };
  }

  getLocationContent(aem: HeaderFooterMachCore): Location {
    return {
      label: AemPropertyAccessor.getString(aem, 'locationContent.label'),
      placeholder: AemPropertyAccessor.getString(
        aem,
        'locationContent.placeholder'
      ),
      accessibilityLocation: AemPropertyAccessor.getString(
        aem,
        'locationContent.accessibilityLocation'
      )
    };
  }

  getDropDownTravelOptions(aem: HeaderFooterMachCore): DropdownOptions {
    return {
      id: 'dropdownTraveler',
      placeholder:
        aem.header?.book?.stays?.dropDownTravelerOption?.placeholder || '',
      icon: aem.header?.book?.stays?.dropDownTravelerOption?.icon || '',
      items: aem.header?.book.stays?.dropDownTravelerOption?.items?.map(
        (option) => ({
          value: option.value,
          label: option.label,
          icon: aem.header?.book?.stays?.dropDownTravelerOption?.icon || ''
        })
      )
    };
  }

  getDownRoomOption(aem: HeaderFooterMachCore): DropdownOptions {
    return {
      id: 'staysDropdownRoom',
      placeholder:
        aem.header?.book?.stays?.dropDownRoomOption?.placeholder || '',
      icon: aem.header?.book?.stays?.dropDownRoomOption?.icon || '',
      items: aem.header?.book.stays?.dropDownRoomOption?.items?.map(
        (option) => ({
          value: option.value,
          label: option.label,
          icon: aem.header?.book?.stays?.dropDownRoomOption?.icon || ''
        })
      )
    };
  }

  getAccessibility(aem: HeaderFooterMachCore): StaysWidget['accessibility'] {
    return {
      findButtonAriaLabel: AemPropertyAccessor.getString(
        aem,
        'accessibility.findButtonAriaLabel'
      )
    };
  }
}
